// FormField label'ları için Türkçe → İngilizce auto-translate map.
//
// Strateji: FormField'lar yüzlerce sayfada hardcoded `label="X"` ile geçiyor.
// Sayfa sayfa t() ile sarmak büyük refactor; bu map render sırasında otomatik çevirir.
// FormField component'i `useTranslation` ile dili okur ve `fieldLabel(label, lang)` çağırır.
//
// Eşleşme yoksa orijinal TR label aynen döner (graceful fallback).
// Yeni form alanı eklenirken buraya bir satır eklenirse otomatik EN destekli olur.

const FIELD_TR_TO_EN = {
  // ── Genel / Ortak ───────────────────────────────────────
  'Kod': 'Code',
  'Ad': 'Name',
  'Adı': 'Name',
  'Ad Soyad': 'Full Name',
  'Ünvan': 'Title',
  'Açıklama': 'Description',
  'Notlar': 'Notes',
  'Not': 'Note',
  'Durum': 'Status',
  'Tip': 'Type',
  'Tipi': 'Type',
  'Kategori': 'Category',
  'Grup': 'Group',
  'Para Birimi': 'Currency',
  'Tarih': 'Date',
  'Başlangıç Tarihi': 'Start Date',
  'Bitiş Tarihi': 'End Date',
  'Vade Tarihi': 'Due Date',
  'Verilme Tarihi': 'Issue Date',
  'Son Tarih': 'Expiry Date',
  'Aktif': 'Active',
  'Pasif': 'Inactive',
  'Etiket': 'Label',
  'Renk': 'Color',
  'Sıra': 'Order',
  'Sıralama': 'Sort Order',

  // ── İletişim ────────────────────────────────────────────
  'Telefon': 'Phone',
  'Telefon 2': 'Phone 2',
  'Cep Telefonu': 'Mobile',
  'Mobil': 'Mobile',
  'Faks': 'Fax',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Email': 'Email',
  'Web Sitesi': 'Website',
  'Adres': 'Address',
  'Şehir': 'City',
  'İlçe': 'District',
  'Ülke': 'Country',
  'Posta Kodu': 'Postal Code',

  // ── Cari / Vergi ────────────────────────────────────────
  'Cari Kodu': 'Account Code',
  'Cari Tipi': 'Account Type',
  'Cari Adı': 'Account Name',
  'Cari Ünvanı': 'Account Title',
  'Kişi Tipi': 'Identity Type',
  'TC Kimlik No': 'National ID',
  'Vergi No': 'Tax Number',
  'Vergi No (VKN)': 'Tax Number (VKN)',
  'Vergi Dairesi': 'Tax Office',
  'VKN': 'Tax Number',
  'Sektör': 'Sector',
  'Bölge': 'Region',
  'Özel Kod': 'Special Code',
  'Satış Temsilcisi': 'Sales Rep',
  'Bağlı Şube': 'Branch',
  'Şube': 'Branch',
  'Kredi Limiti': 'Credit Limit',
  'Vade (gün)': 'Payment Term (days)',
  'Vade Günü': 'Payment Term',
  'İskonto Oranı': 'Discount Rate',
  'Bakiye': 'Balance',
  'Açılış Bakiyesi': 'Opening Balance',

  // ── Stok / Ürün ─────────────────────────────────────────
  'Stok Kodu': 'Stock Code',
  'Stok Adı': 'Stock Name',
  'Stok / Ürün': 'Stock / Product',
  'Ürün Adı': 'Product Name',
  'Barkod': 'Barcode',
  'Birim': 'Unit',
  'Birim 1': 'Unit 1',
  'Birim 2': 'Unit 2',
  'Birim 3': 'Unit 3',
  'KDV Oranı': 'VAT Rate',
  'ÖTV Oranı': 'SCT Rate',
  'Marka': 'Brand',
  'Üretici': 'Manufacturer',
  'Model': 'Model',
  'Üretim Yeri': 'Country of Origin',
  'GTİP': 'HS Code',
  'Stokta Tutulur': 'Track Inventory',
  'Negatif Satılabilir': 'Allow Negative',
  'Renk / Beden Takibi': 'Color / Size Tracking',
  'Seri Takibi': 'Serial Tracking',
  'Lot Takibi': 'Lot Tracking',
  'Minimum Stok': 'Min Stock',
  'Maksimum Stok': 'Max Stock',
  'Yeniden Sipariş Noktası': 'Reorder Point',
  'Ağırlık': 'Weight',
  'Hacim': 'Volume',
  'En': 'Width',
  'Boy': 'Length',
  'Yükseklik': 'Height',
  'Alış Fiyatı': 'Purchase Price',
  'Satış Fiyatı': 'Sales Price',
  'Liste Fiyatı': 'List Price',
  'Maliyet': 'Cost',
  'Fiyat': 'Price',
  'Fiyat Tanımı': 'Price Definition',

  // ── Fatura / Belge ──────────────────────────────────────
  'Belge No': 'Document No',
  'Fatura No': 'Invoice No',
  'Sipariş No': 'Order No',
  'İrsaliye No': 'Waybill No',
  'Teklif No': 'Quote No',
  'Makbuz No': 'Receipt No',
  'Dekont No': 'Voucher No',
  'Referans No': 'Reference No',
  'Fatura Tarihi': 'Invoice Date',
  'Sipariş Tarihi': 'Order Date',
  'Sevk Tarihi': 'Dispatch Date',
  'Teslim Tarihi': 'Delivery Date',
  'Müşteri': 'Customer',
  'Tedarikçi': 'Supplier',
  'Cari': 'Account',
  'Depo': 'Warehouse',
  'Personel': 'Personnel',
  'Proje': 'Project',
  'Miktar': 'Quantity',
  'Birim Fiyat': 'Unit Price',
  'Tutar': 'Amount',
  'Net Tutar': 'Net Amount',
  'Brüt Tutar': 'Gross Amount',
  'Toplam': 'Total',
  'Ara Toplam': 'Subtotal',
  'İskonto': 'Discount',
  'KDV': 'VAT',
  'Vergi': 'Tax',
  'Genel Toplam': 'Grand Total',
  'Yuvarlama': 'Rounding',
  'Vade Farkı': 'Late Charge',
  'Komisyon': 'Commission',
  'Stopaj': 'Withholding',
  'Ödeme Şekli': 'Payment Method',
  'Ödenecek': 'Payable',
  'Tahsil Edilecek': 'Receivable',
  'Ödenen': 'Paid',
  'Kalan': 'Remaining',

  // ── Banka / Kasa ────────────────────────────────────────
  'Banka': 'Bank',
  'Banka Adı': 'Bank Name',
  'Hesap Adı': 'Account Name',
  'Şube Adı': 'Branch Name',
  'Hesap No': 'Account No',
  'IBAN': 'IBAN',
  'SWIFT': 'SWIFT',
  'Hesap Tipi': 'Account Type',
  'Mevcut Bakiye': 'Current Balance',
  'Kasa': 'Cash Register',
  'Kasa Adı': 'Cash Register Name',
  'POS': 'POS',
  'POS Adı': 'POS Name',
  'Merchant ID (Üye İşyeri No)': 'Merchant ID',
  'Terminal ID': 'Terminal ID',
  'Komisyon Oranı': 'Commission Rate',
  'Bloke Günü': 'Blocking Days',
  'Taksit Sayısı': 'Installments',
  'Kart Tipi': 'Card Type',

  // ── Çek / Senet ─────────────────────────────────────────
  'Çek No': 'Check No',
  'Senet No': 'Note No',
  'Seri No': 'Serial No',
  'Düzenleyen': 'Issuer',
  'Düzenleyen Adı': 'Issuer Name',
  'Lehtar': 'Payee',

  // ── Personel ────────────────────────────────────────────
  'Personel Adı': 'Personnel Name',
  'Ad (İsim)': 'First Name',
  'Soyad': 'Last Name',
  'Doğum Tarihi': 'Birth Date',
  'Cinsiyet': 'Gender',
  'Departman': 'Department',
  'Pozisyon': 'Position',
  'İşe Giriş Tarihi': 'Hire Date',
  'Maaş': 'Salary',
  'Resmi Maaş': 'Official Salary',
  'İşten Çıkış Tarihi': 'Termination Date',
  'Çıkış Nedeni': 'Termination Reason',
  'Satış Temsilcisi mi?': 'Is Sales Rep',
  'Depo Personeli mi?': 'Is Warehouse Staff',
  'Şoför mü?': 'Is Driver',
  'Plasiyer mi?': 'Is Sales Rep',

  // ── Yönetici / Sorumlu ──────────────────────────────────
  'Sorumlu': 'Responsible',
  'Sorumlu Personel': 'Responsible Personnel',
  'Yönetici': 'Manager',
  'Şube Yöneticisi (Personel)': 'Branch Manager (Personnel)',
  'Şube Yöneticisi': 'Branch Manager',

  // ── Kullanıcı / Yetki ──────────────────────────────────
  'Kullanıcı Adı': 'Username',
  'Şifre': 'Password',
  'Yeni Şifre': 'New Password',
  'Rol': 'Role',
  'Roller': 'Roles',
  'İzinler': 'Permissions',
  'Varsayılan Depo': 'Default Warehouse',
  'Varsayılan Kasa': 'Default Cash Register',
  'Varsayılan Şube': 'Default Branch',
  'Dil': 'Language',
  'Tema': 'Theme',

  // ── DataTable Kolon Başlıkları (extra) ─────────────────
  'Sehir': 'City',
  'Sorumlu': 'Responsible',
  'Hesap Adi': 'Account Name',
  'Belge Adı': 'Document Name',
  'Borç': 'Debit',
  'Alacak': 'Credit',
  'Bakiyesi': 'Balance',
  'Risk': 'Risk',
  'Kredi Limit': 'Credit Limit',
  'Boyut': 'Size',
  'Sayfa': 'Page',
  'Toplam Tutar': 'Total Amount',
  'Net Toplam': 'Net Total',
  'KDV Toplam': 'VAT Total',
  'Yüklendi': 'Loaded',
  'Tamamlandı': 'Completed',
  'Onaylandı': 'Approved',
  'Beklemede': 'Pending',
  'Onaylı': 'Approved',
  'Reddedildi': 'Rejected',
  'İptal': 'Cancelled',
  'Taslak': 'Draft',
  'Açık': 'Open',
  'Kapalı': 'Closed',
  'Tahsil Edildi': 'Collected',
  'Ödendi': 'Paid',
  'Portföy': 'Portfolio',
  'Karşılıksız': 'Dishonored',
  'Bankaya Verilmiş': 'Given to Bank',
  'Ciro Edilmiş': 'Endorsed',
  'Kullanıldı': 'Used',
  'Düzenlendi': 'Issued',
  'Eklenen': 'Added',
  'Güncellenen': 'Updated',
  'Silinen': 'Deleted',
  'Oluşturma Tarihi': 'Created At',
  'Güncelleme Tarihi': 'Updated At',
  'Oluşturan': 'Created By',
  'Güncelleyen': 'Updated By',
  'Son Hareket': 'Last Activity',
  'Görüntüle': 'View',
  'İşlemler': 'Actions',
  'Seç': 'Select',

  // ── ActionsMenu / Buton Label'ları ──────────────────────
  'İşlemler': 'Actions',
  'Düzenle': 'Edit',
  'Sil': 'Delete',
  'Görüntüle': 'View',
  'Kopya Oluştur': 'Duplicate',
  'Kopyala': 'Copy',
  'Yazdır': 'Print',
  'PDF İndir': 'Download PDF',
  'Excel\'e Aktar': 'Export to Excel',
  'CSV İndir': 'Download CSV',
  'Yenile': 'Refresh',
  'Yenile (↻)': 'Refresh (↻)',
  'Kaydet': 'Save',
  'Kaydet ve Kapat': 'Save & Close',
  'Kaydet ve Yeni Aç': 'Save & New',
  'İptal': 'Cancel',
  'Vazgeç': 'Cancel',
  'Kapat': 'Close',
  'Tamam': 'OK',
  'Evet': 'Yes',
  'Hayır': 'No',
  'Onayla': 'Approve',
  'Reddet': 'Reject',
  'Gönder': 'Send',
  'Geri Al': 'Undo',
  'İptal Et': 'Cancel',
  'Yeni': 'New',
  'Ekle': 'Add',
  '+ Yeni': '+ New',
  'Faturayı Göster': 'Show Invoice',
  'Belgeyi Göster': 'Show Document',
  'Detaya Git': 'Go to Detail',
  'Çoğalt': 'Duplicate',
  'Aktif Et': 'Activate',
  'Pasif Et': 'Deactivate',
  'Bağlantıyı Kopyala': 'Copy Link',
  'Tahsil Et': 'Collect',
  'Öde': 'Pay',
  'Ata': 'Assign',
  'Çoğaltma': 'Duplicate',
  'Belgeleri İndir': 'Download Documents',
  'Bekleyenlere Bak': 'View Pending',
  'Onay Bekleyenler': 'Pending Approvals',
  'Tarih Aralığı': 'Date Range',
  'Filtreyi Temizle': 'Clear Filter',

  // ── Diğer ───────────────────────────────────────────────
  'Resim': 'Image',
  'Logo': 'Logo',
  'Dosya': 'File',
  'Yorum': 'Comment',
  'Etiketler': 'Tags',
  'Adet': 'Quantity',
  'Oran': 'Rate',
  'Yüzde': 'Percentage',
  'Yer / Konum': 'Location',
  'Kapasite': 'Capacity',
  'Kapasite Birimi': 'Capacity Unit',
  'Depo Kodu': 'Warehouse Code',
  'Depo Adi': 'Warehouse Name',
  'Depo Tipi': 'Warehouse Type',
  'Şube Kodu': 'Branch Code',
  'Şube Adı': 'Branch Name',
  'Şube Tipi': 'Branch Type',
  'Kasa Adı': 'Cash Register Name',
};

export function fieldLabel(label, lang) {
  if (!label) return label;
  if ((lang || 'tr').startsWith('tr')) return label;
  // Sondaki * (zorunlu) işaretini koru
  const m = String(label).match(/^(.+?)\s*(\*?)$/);
  if (!m) return FIELD_TR_TO_EN[label] || label;
  const base = m[1].trim();
  const star = m[2];
  const en = FIELD_TR_TO_EN[base];
  return en ? (en + (star ? ' *' : '')) : label;
}

export default FIELD_TR_TO_EN;
